import React from "react";
import { Radio, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { useSharedDraft } from "@/lib/sharedDraft";
import { WordingFeedbackLog } from "@/components/WordingFeedback";
import { BriefViewer } from "@/components/Brief";

const PREFIX = { model: "model_", draft: "draft_", quick: "quick_", compare: "quick_" };

/** Live-sharing status: who else is on this page, start-fresh, and the wording feedback log. */
export function DraftPresence({ mode }) {
  const { viewers, me, clear } = useSharedDraft();
  const others = viewers.filter((v) => v.id !== me?.id);
  return (
    <div className="space-y-2" data-testid="draft-presence">
    <div className="flex items-center gap-3 flex-wrap text-xs">
      <span className="inline-flex items-center gap-1.5 text-emerald-300">
        <Radio className="w-3.5 h-3.5" /> Live with your workgroup
      </span>
      <span className="text-muted-foreground" data-testid="draft-viewers">
        {others.length ? `Also here: ${others.map((o) => o.name).join(", ")}` : "No one else here right now"}
      </span>
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <Button size="sm" variant="ghost" className="h-7 text-xs" data-testid="draft-start-fresh-btn">
            <RotateCcw className="w-3 h-3 mr-1" /> Start fresh
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Start fresh for everyone?</AlertDialogTitle>
            <AlertDialogDescription>This clears the fields and results of this mode for everyone in your workgroup. Saved checks in History are kept.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="draft-start-fresh-cancel">Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={() => clear(PREFIX[mode])} data-testid="draft-start-fresh-confirm">Clear it</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
      <BriefViewer />
    </div>
    <WordingFeedbackLog />
    </div>
  );
}
